module.exports = __webpack_public_path__ + "imgs/advocacy-hero.765104a9e7032e93446ecc796c0466fc.svg";